// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"49":"join","443":"about","587":"community","631":"contact","860":"menu"}[chunkId] + "." + {"49":"b7384982","443":"70d06baf","587":"a698494b","631":"6ea06f1c","860":"12e6d970"}[chunkId] + ".js";
};